import React from 'react';
import toFaNumber, {toFaNumberFormat} from "@/lib/utils/number";
import TableSearch from '@/components/table/tableSearch';
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {useApiSearchStudentPayments} from "@/api/payment";
import RenderIf from "@/components/render-if";
import {Tag} from "antd";

function StudentBillingListSection() {
    const columns = [
        {
            title: 'شناسه',
            dataIndex: 'id',
            key: 'id',
            responsive: ['md'],
            render: (text) => toFaNumber(text)
        },
        {
            title: 'عنوان',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => {
                return (<>
                    <div className="flex gap-2">
                        <div>{record?.title}</div>

                        <RenderIf condition={record?.related && record?.related === 'lesson'}>
                            <Tag>درس {record?.related_id}</Tag>
                        </RenderIf>
                    </div>


                </>)
            }
        },
        {
            title: 'مبلغ',
            dataIndex: 'amount',
            key: 'amount',
            render: function (text, record) {
                if (parseInt(record?.plus) > 0) {
                    return (<span className={'text-green-600'}>{toFaNumberFormat(record.plus)}+</span>)
                }

                if (parseInt(record?.minus) > 0) {
                    return (<span className={'text-red-600'}>{toFaNumberFormat(record.minus)}-</span>)
                }
            }
        },
        {
            title: 'تاریخ',
            dataIndex: 'datecreated',
            key: 'datecreated',
            responsive: ['md'],
            render: (text) => convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD HH:mm:ss')
        },


        {
            title: ' ',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {

            }
        },
    ];

    return (

        <TableSearch
            searchInput={false}
            apiFn={useApiSearchStudentPayments}
            columns={columns}
            scroll={{x: true}}
            responsive={true}
        />

    );
}

export default StudentBillingListSection;